import React from 'react'

const Badge = props => (
  <svg
    height={props.height}
    viewBox="0 0 158 157"
    xmlns="http://www.w3.org/2000/svg"
  >
    <defs>
      <circle id="badge5_a" cx="55.02" cy="55.09" r="54.65" />
    </defs>
    <g transform="translate(0 -1)" fill="none">
      <circle fill="#00B4FF" cx="79.29" cy="79.09" r="54.66" />
      <path
        d="M78.08 4.31c1.8 0 4.62-3.43 6.42-3.31 1.8.12 4.11 3.9 5.9 4.18 1.79.28 5.12-2.63 6.88-2.21 1.76.42 3.41 4.52 5.13 5.08 1.72.56 5.48-1.75 7.15-1s2.62 5 4.22 5.86c1.6.86 5.7-.82 7.22.15 1.52.97 1.76 5.38 3.21 6.48 1.45 1.1 5.75.12 7.1 1.33 1.35 1.21.85 5.6 2.09 6.91 1.24 1.31 5.66 1.07 6.78 2.48s-.08 5.67.93 7.17 5.4 2 6.28 3.57c.88 1.57-1 5.57-.26 7.21.74 1.64 5 2.86 5.61 4.56.61 1.7-1.92 5.33-1.46 7.07.46 1.74 4.47 3.64 4.79 5.42.32 1.78-2.77 4.94-2.6 6.74.17 1.8 3.81 4.32 3.83 6.13.02 1.81-3.55 4.42-3.67 6.22-.12 1.8 3 4.89 2.77 6.67-.23 1.78-4.22 3.78-4.65 5.54-.43 1.76 2.2 5.32 1.64 7-.56 1.68-4.79 3-5.49 4.7-.7 1.7 1.29 5.61.45 7.21-.84 1.6-5.23 2.2-6.2 3.72-.97 1.52.36 5.76-.74 7.2-1.1 1.44-5.51 1.31-6.72 2.65-1.21 1.34-.6 5.73-1.91 7-1.31 1.27-5.65.38-7.07 1.51s-1.53 5.55-3 6.56c-1.47 1.01-5.64-.56-7.22.33-1.58.89-2.42 5.22-4.07 6-1.65.78-5.47-1.47-7.17-.86-1.7.61-3.26 4.75-5 5.22-1.74.47-5.16-2.36-6.94-2-1.78.36-4 4.15-5.78 4.32-1.78.17-4.7-3.17-6.51-3.15-1.81.02-4.62 3.44-6.42 3.31-1.8-.13-4.12-3.89-5.9-4.17-1.78-.28-5.12 2.63-6.88 2.21-1.76-.42-3.42-4.52-5.13-5.09-1.71-.57-5.49 1.75-7.15 1-1.66-.75-2.62-5-4.22-5.86-1.6-.86-5.71.82-7.23-.15-1.52-.97-1.76-5.38-3.2-6.47-1.44-1.09-5.76-.13-7.1-1.34-1.34-1.21-.85-5.6-2.09-6.91-1.24-1.31-5.7-1.14-6.82-2.5s.08-5.67-.92-7.17-5.41-2-6.29-3.57c-.88-1.57 1-5.57.27-7.22-.73-1.65-5-2.85-5.61-4.55-.61-1.7 1.92-5.33 1.45-7.08S2.32 94.74 2 93c-.32-1.74 2.76-4.94 2.59-6.74-.17-1.8-3.8-4.32-3.83-6.13-.03-1.81 3.55-4.42 3.67-6.22.12-1.8-3-4.89-2.76-6.67.24-1.78 4.22-3.79 4.64-5.54.42-1.75-2.2-5.32-1.63-7 .57-1.68 4.79-3 5.49-4.69.7-1.69-1.29-5.61-.45-7.21.84-1.6 5.22-2.2 6.19-3.73.97-1.53-.35-5.74.74-7.19 1.09-1.45 5.52-1.31 6.72-2.65 1.2-1.34.6-5.73 1.92-7 1.32-1.27 5.65-.38 7.06-1.51 1.41-1.13 1.53-5.55 3-6.56 1.47-1.01 5.65.55 7.22-.33 1.57-.88 2.43-5.22 4.08-6 1.65-.78 5.47 1.48 7.17.87 1.7-.61 3.25-4.75 5-5.22 1.75-.47 5.15 2.35 6.93 2 1.78-.35 4-4.15 5.79-4.32 1.79-.17 4.73 3.18 6.54 3.15z"
        fill="#00B4FF"
      />
      <circle fill="#00B4FF" cx="79.03" cy="79.09" r="74.41" />
      <path
        d="M135.23 79.09c0 31.034-25.156 56.194-56.19 56.2-31.035.006-56.199-25.146-56.21-56.18C22.819 48.075 47.966 22.907 79 22.89a56.2 56.2 0 0 1 56.23 56.2zM48.73 21.35L51.27 20l1.66 3.17a8 8 0 0 1-2.08 1.55 3.12 3.12 0 0 1-2.52.31 3.57 3.57 0 0 1-1.93-1.86 3.38 3.38 0 0 1-.35-2.64 3.53 3.53 0 0 1 1.87-2 6.37 6.37 0 0 1 1.1-.45 5.18 5.18 0 0 1 1-.18l.15 1.51a3.44 3.44 0 0 0-1.56.42 1.46 1.46 0 0 0-.84 1 2.15 2.15 0 0 0 .3 1.49 2.26 2.26 0 0 0 1 1.08c.397.17.852.136 1.22-.09.222-.112.43-.25.62-.41l-.49-.9-1 .55-.69-1.2zM55.39 19.89l.88 2.26-1.68.65-2.4-6.2 2-.78c1.68-.66 2.76-.37 3.23.85a2 2 0 0 1-.4 2.07l2.85 2-1.9.73-2.18-1.74-.4.16zm-.49-1.25l.32-.13c.58-.22.77-.59.57-1.11-.16-.43-.53-.53-1.11-.31l-.33.13.55 1.42zM64.71 19.45l-.63-1.12-2.08.55v1.29l-1.9.5.39-7 2.32-.61 3.8 5.94-1.9.45zM63.34 17l-.55-1a26.874 26.874 0 0 1-.87-1.6V17.34l1.42-.34zM70.51 18.37l-1.77.27-.74-5.12-1.6.25-.23-1.45 5-.77.23 1.45-1.6.25zM78.68 11.08l.19 4a2.68 2.68 0 0 1-.65 2 2.92 2.92 0 0 1-2.09.81 2.88 2.88 0 0 1-2.12-.59 2.63 2.63 0 0 1-.82-2l-.19-4 1.8-.09.18 3.9c-.007.36.106.711.32 1a.93.93 0 0 0 .79.28 1 1 0 0 0 .78-.35 1.76 1.76 0 0 0 .2-1l-.18-3.88 1.79-.08zM80.69 17.78l.39-6.64 1.79.11-.3 5.18 2.55.15L85 18zM90.43 18.83l-.12-1.29-2.13-.35-.54 1.18-1.94-.32 3.22-6.23 2.36.38 1.09 6.94-1.94-.31zm-.25-2.8l-.11-1.12c0-.25 0-.57-.08-1-.08-.43 0-.68-.06-.85-.05.15-.14.39-.28.73-.14.34-.42 1-.87 2l1.4.24zM97.59 15.14a1.13 1.13 0 0 0-1.1.23 2.58 2.58 0 0 0-.74 1.3c-.34 1.23 0 2 .89 2.24.28.081.57.119.86.11.294 0 .588-.02.88-.06L98 20.42a4.52 4.52 0 0 1-1.91-.15 3 3 0 0 1-2-1.46 3.56 3.56 0 0 1-.09-2.64 4 4 0 0 1 .86-1.65 2.76 2.76 0 0 1 1.4-.85 3.41 3.41 0 0 1 1.76.05 4.76 4.76 0 0 1 1.86 1L99 15.94a4.77 4.77 0 0 0-.63-.48 2.42 2.42 0 0 0-.78-.32zM98.23 23a4.1 4.1 0 0 1-.84-.41l.48-1.31.27.17c.102.06.209.11.32.15a.72.72 0 0 0 .69 0 1.58 1.58 0 0 0 .5-.79l2.14-5.81 1.69.63-2.08 5.62a3.09 3.09 0 0 1-1.27 1.75c-.6.294-1.3.294-1.9 0zM106.41 24.18l-3.59-1.64 2.77-6 3.59 1.64-.6 1.31-2-.89-.43 1 1.81.82-.6 1.32-1.81-.83-.48 1.09 2 .89zM107.81 24.09a.8.8 0 0 1 .53-.45 1 1 0 0 1 .73.14 1 1 0 0 1 .51.53 1 1 0 0 1-.62 1.13 1 1 0 0 1-.72-.13 1.09 1.09 0 0 1-.51-.54.83.83 0 0 1 .08-.68zm2.27-.58l-1.32-.72 1.85-3.89 1.73.94-2.26 3.67zM58.47 142.45l-.72 2.31-1.75-.54 2-6.35 2.08.66c1.72.54 2.39 1.43 2 2.68a2 2 0 0 1-1.62 1.37l1 3.35-1.94-.61-.62-2.74-.43-.13zm.41-1.29l.32.1c.6.19 1 0 1.15-.51.15-.51-.09-.75-.68-.94l-.34-.1-.45 1.45zM69.35 144.15a3.58 3.58 0 0 1-1.35 2.34 3.72 3.72 0 0 1-4.72-1 3.57 3.57 0 0 1-.31-2.67 3.5 3.5 0 0 1 1.31-2.32 3.13 3.13 0 0 1 2.54-.39 3.16 3.16 0 0 1 2.19 1.33 3.59 3.59 0 0 1 .34 2.71zm-4.49-.9c-.25 1.26.06 2 .94 2.16.38.104.789.006 1.08-.26a3.41 3.41 0 0 0 .57-2.88 1.1 1.1 0 0 0-.88-.66c-.89-.18-1.46.39-1.71 1.64zM71 141l2.31.21a4 4 0 0 1 2 .58c.408.304.615.807.54 1.31a1.62 1.62 0 0 1-.37.93 1.33 1.33 0 0 1-.8.44c.348.105.649.327.85.63.165.306.228.656.18 1a1.7 1.7 0 0 1-.8 1.36 3 3 0 0 1-1.9.35l-2.58-.23L71 141zm1.44 4l-.13 1.4.63.05c.56 0 .86-.15.9-.63a.62.62 0 0 0-.17-.52 1 1 0 0 0-.64-.24l-.59-.06zm.12-1.31l.54.05a1 1 0 0 0 .61-.1.54.54 0 0 0 .25-.45c0-.37-.23-.59-.79-.64h-.5l-.11 1.14zM83.39 144.73a3.63 3.63 0 0 1-.79 2.57 3.74 3.74 0 0 1-4.81.07 4.34 4.34 0 0 1-.09-5.09 3.77 3.77 0 0 1 4.83-.09c.6.706.908 1.615.86 2.54zm-4.58.08c0 1.28.48 1.92 1.37 1.91a1.16 1.16 0 0 0 1-.49 3.46 3.46 0 0 0 0-2.93 1.13 1.13 0 0 0-1-.46c-.95.01-1.39.67-1.37 1.97zM88.05 147.55l-1.79.21-.61-5.15-1.61.19-.17-1.46 5-.59.18 1.46-1.61.19zM92.5 142.53l.61-2.65 1.9-.41-1.29 4.42.54 2.54-1.77.38-.53-2.49-3-3.56 1.91-.41zM103 143.91l-1.93.62-2-2-.41.47.68 2.12-1.72.55-2-6.34 1.73-.55.87 2.75c0-.19.13-.52.27-1l.71-2.37 1.87-.6L99.9 141l3.1 2.91z"
        fill="#FFF"
      />
      <circle fill="#FFF" cx="144.89" cy="78.52" r="3.64" />
      <circle fill="#FFF" cx="143.88" cy="90.83" r="2.79" />
      <circle fill="#FFF" cx="141.02" cy="101.61" r="2.1" />
      <circle fill="#FFF" cx="143.88" cy="66.2" r="2.79" />
      <circle fill="#FFF" cx="141.02" cy="55.43" r="2.1" />
      <circle fill="#FFF" cx="13.69" cy="78.52" r="3.64" />
      <circle fill="#FFF" cx="14.69" cy="90.83" r="2.79" />
      <circle fill="#FFF" cx="17.56" cy="101.61" r="2.1" />
      <circle fill="#FFF" cx="14.69" cy="66.2" r="2.79" />
      <circle fill="#FFF" cx="17.56" cy="55.43" r="2.1" />
      <circle fill="#FBC53B" cx="79.29" cy="79.09" r="54.66" />
      <g transform="translate(24 24)">
        <mask id="badge5_b" fill="#fff">
          <use href="#badge5_a" />
        </mask>
        <g mask="url(#badge5_b)">
          <g transform="translate(-55 4)">
            <path
              d="M146.07 23.22a1.77 1.77 0 0 1-2.92-.54 1.76 1.76 0 0 1 1.93-2.42 1.76 1.76 0 0 1 1 3l-.01-.04zM152.9 29.54a1.79 1.79 0 0 1-1.83.47l-.26-.11a1.71 1.71 0 0 1-.42-.3 1.76 1.76 0 0 1-.06-2.5 1.71 1.71 0 0 1 .62-.42 1.75 1.75 0 0 1 1.88.35 2 2 0 0 1 .32.4c.052.096.095.197.13.3a.65.65 0 0 1 0 .13 1.76 1.76 0 0 1-.38 1.68z"
              fill="#593730"
            />
            <path
              d="M152.38 29a5.8 5.8 0 0 1-1.09.9l-.22.14-.23.12a5.68 5.68 0 0 1-6.72-8.94 5.81 5.81 0 0 1 1.33-1.04 5.7 5.7 0 0 1 1.98-.67c.189-.03.38-.05.57-.06h.55a5.64 5.64 0 0 1 2.51.73l.3.19.24.16.18.15c.13.098.254.205.37.32a5.62 5.62 0 0 1 1.77 4v.19a4.32 4.32 0 0 1-.05.62 2.08 2.08 0 0 1 0 .23 5.72 5.72 0 0 1-.2.79 5.48 5.48 0 0 1-.38.91l-.1.18a5.66 5.66 0 0 1-.81 1.08z"
              fill="#593730"
            />
            <path
              d="M145.7 22s-1.23 1.3-2 1.13a4 4 0 0 1 1.48-1.59l.52.46zM151.54 27.54s-1.23 1.3-1 2a4.81 4.81 0 0 0 1.57-1.77l-.57-.23z"
              fill="#593730"
            />
            <ellipse
              fill="#020202"
              cx="86.77"
              cy="5.97"
              rx="86.77"
              ry="5.59"
              opacity=".15"
              transform="translate(0 128)"
            />
            <path
              d="M19.08 134.76A106.08 106.08 0 0 1 7 134a.574.574 0 0 1 .13-1.14c20 2.28 34.62-.85 43.33-9.31a28.53 28.53 0 0 0 8.32-21.05.59.59 0 0 1 .53-.62.58.58 0 0 1 .62.52c0 .13 1 12.62-8.67 22-7.09 6.89-17.89 10.36-32.18 10.36z"
              fill="#588489"
            />
            <path
              d="M19.86 134.76c-2.393 0-4.863-.077-7.41-.23a.57.57 0 0 1-.54-.61.58.58 0 0 1 .6-.54c20.86 1.25 36-2.64 45-11.59a27.55 27.55 0 0 0 8.25-19.27.57.57 0 0 1 .54-.61.58.58 0 0 1 .6.55 28.18 28.18 0 0 1-8.58 20.14c-8.15 8.08-21.05 12.16-38.46 12.16z"
              fill="#E6F9FC"
            />
            <path
              d="M111.2 131.26c-.98.41-1.982.767-3 1.07l-.43.12c-7.43 2.06-17.64 2.33-26.75 2h-.77c-6.75-.28-12.82-.89-16.61-1.33a1.84 1.84 0 0 1-1.25-2.95 29 29 0 0 0 3.39-5.91 17.22 17.22 0 0 0-.5-14.92s5.89-25.45 6.27-26.09c.38-.64 38.6-6.38 36.27.66-2.33 7.04-2.22 26.63-1.58 33.26.43 4.51 3.64 8.91 5.65 11.26a1.83 1.83 0 0 1-.69 2.83z"
              fill="#DFF0F4"
            />
            <path
              d="M103.19 92s-23 27.25-36 25.75c0 0-.14-6.25-2.21-8.51a24.26 24.26 0 0 0 11.52-1.17C82.58 105.9 103.19 92 103.19 92z"
              fill="#2B2B2B"
            />
            <path
              d="M120.17 70.32l-15.68 10.14-28-68.34a13.35 13.35 0 0 1 2.94-1.06 35.21 35.21 0 0 1 4-.76c.83-.12 1.73-.22 2.72-.3 1.22-.1 2.58-.17 4.07-.19h2.64l2.06.06c.79 0 1.56.1 2.32.19 17.82 2.07 26.57 18.56 26.57 18.56 10.71 21.23-3.64 41.7-3.64 41.7z"
              fill="#4C2D91"
            />
            <path
              fill="#5E97CE"
              d="M94.35 16.33l2.21-3.78 4.89 1.6-1.11 3.64 3.17 1.38 2.55-2.92 3.93 2.82-2.05 3.12 1.94 1.97 1.96-1.84 3.3 3.94-4.63 4.55-11.15-3.4z"
            />
            <path
              d="M97.24 10.06L95 18.84l-8.91-.48-5.94-5-.72-2.3a35.21 35.21 0 0 1 4-.76l1 3.78 1.72-.83V10c1.22-.1 2.58-.17 4.07-.19l-.14 4.81 1.24 1.73 1.54-6.54 2.06.06c.79.04 1.56.13 2.32.19z"
              fill="#93278F"
            />
            <path
              d="M128.79 44.78c-.87.83-2.55 2.78-2.55 2.78l7.58 10.11a5.48 5.48 0 0 0 8.26-1.94l5-10.13-7.43-1.6-2.07 7.46-8.79-6.68z"
              fill="#EDEDED"
            />
            <path
              d="M115.22 31.29l3.06-3.19 3.06 3.52 3.28-1 .17-4.49 4.8.48-.51 4.58 2.41 1.38 3.44-2.77 2.72 3.28-3.05 3.28.43 2.25 3.86 1.39-1.89 4.5-3.28-1.87-1 1.64c.32.58 2 3.35 2 3.35l-3.56 2.21-1.75-3.78-1.68.48v3.65l-4.25-.11v-3.71l-2.11-.46-2.19 2.76-3.18-2.87 2.67-3-.53-1.29-3.36.62-1.3-6.12 4.73-.72-.5-.81-2.49-3.18z"
              fill="#5E97CE"
            />
            <path
              d="M126.18 44.78a6.12 6.12 0 1 1 6.11-6.12 6.13 6.13 0 0 1-6.11 6.12zm0-11.85a5.74 5.74 0 1 0-.02 11.48 5.74 5.74 0 0 0 .02-11.48z"
              fill="#236"
            />
            <circle fill="#236" cx="126.18" cy="38.66" r="2.61" />
            <path
              d="M136.41 96.55l2.36-37.28s-.1-7.64.43-13.18a9 9 0 0 1 5.17-7.3v.71l1.25 25.31 1.5 31.81-10.71-.07z"
              fill="#FFF"
            />
            <path
              d="M70.27 14.78a.33.33 0 1 0 .66 0 .33.33 0 0 0-.66 0z"
              fill="#565656"
            />
            <circle fill="#565656" cx="70.6" cy="20.79" r="1" />
            <path
              d="M108.3 132.18c-8.58-7.92-10-18.33-9.68-25.66a49 49 0 0 1 2.84-14.37l.07-.17-.71-.28-.07.18a49.62 49.62 0 0 0-2.9 14.59c-.33 7.44 1.1 18 9.76 26.12l.07.07h.11l.43-.12.32-.1-.24-.26zM81 134.44h-.77c4.66-23.07-3.74-25.92-3.82-25.94a.39.39 0 1 1 .22-.74c.37.07 9.13 2.92 4.37 26.68z"
              fill="#8DADB2"
            />
            <path
              fill="#93278F"
              d="M116.07 36.62l2.06 4.86-1.32.29-.38.08-5.54 1.21-6.02-11.17 3.44-2.74-1-1.57-.25-.38-.93-.78h6.9l-.25 3.67 1.63 1.01 3.56-1.3 2.11 5.07z"
            />
            <path
              d="M117.1 31.52L114 32.6a.17.17 0 0 1-.18 0l-2.48-2.05a.18.18 0 0 1-.06-.15l.13-2.85-4.09.07h-.81a.19.19 0 0 1-.2-.18.2.2 0 0 1 .19-.2h.57l4.53-.08a.18.18 0 0 1 .14.06.2.2 0 0 1 .06.14l-.14 3L114 32.2l3.18-1.1a.18.18 0 0 1 .23.1l1.26 3.1a.2.2 0 0 1 0 .15.18.18 0 0 1-.11.1l-4 1.5 2.27 5.72-.38.08-2.34-5.85a.16.16 0 0 1 0-.15.13.13 0 0 1 .1-.1l4-1.5-1.11-2.73z"
              fill="#4C2D91"
            />
            <path
              d="M113.28 34.67a2.38 2.38 0 1 1-4.76.02 2.38 2.38 0 0 1 4.76-.02z"
              fill="#4C2D91"
            />
            <path
              d="M113.09 63.43v.49c-.46 5.07-4.87 21.49-8.38 26.48C101 95.57 77.9 108 73.88 109.15a38.08 38.08 0 0 1-6.77 1.4c-4.29.43-9.19-.15-12.17-4.27a16.27 16.27 0 0 1-1.22-2.12c-.42-.85-.87-1.86-1.34-3l-.32-.81a56.6 56.6 0 0 1-3.43-12.84c-.49-3.94-.73-12.16-1.12-25.31v-.65-1.32-1.5c0-1.21-.08-2.45-.12-3.73a45.93 45.93 0 0 1 1.11-12c.07-.27.14-.54.2-.81l.21-.77.06-.22a42.61 42.61 0 0 1 7.31-14.87C67.38 10.45 81.91 11.6 81.91 11.6c9.19.76 14.92 3.25 24.3 14.53s7.07 32.87 6.88 37.3z"
              fill="#FFF"
            />
            <path
              d="M55.14 74.21c-2.57 4-.82 5.39.65 6.6.56.46 2.71.67 1.88.74-7 .61-3.63 7.74 1.08 16.07.208.432.327.901.35 1.38 0 .24.45.25.4.52a15.12 15.12 0 0 0-6.81 1.36.38.38 0 0 1-.44-.06l-.12-.29a45.29 45.29 0 0 1-3.5-13c-.56-3.93-.73-12.16-1.12-25.31v-.65-1.32-1.5c0-1.21-.08-2.45-.12-3.73A45.93 45.93 0 0 1 48.5 43c.07-.27.14-.54.2-.81l.21-.77a8.26 8.26 0 0 1 1.38-.1s4.12-4.24 11 2.47c3.59 3.49 2.3 13.33.67 17a104.76 104.76 0 0 1-6.82 13.42z"
              fill="#D9E6E8"
            />
            <path
              d="M82.32 40.55a1.75 1.75 0 1 1-1.74-1.74c.961 0 1.74.779 1.74 1.74z"
              fill="#2E7FDB"
            />
            <path
              d="M81.51 40.55a.94.94 0 1 1-1.88.02.94.94 0 0 1 1.88-.02z"
              fill="#494949"
            />
            <circle fill="#8DADB2" cx="94.46" cy="120.31" r="1.36" />
            <path
              d="M95.19 120.31a.73.73 0 1 1-1.46 0 .73.73 0 0 1 1.46 0z"
              fill="#494949"
            />
            <circle fill="#8DADB2" cx="84.42" cy="130.23" r="1.36" />
            <path
              d="M85.15 130.23a.73.73 0 1 1-1.46 0 .73.73 0 0 1 1.46 0z"
              fill="#494949"
            />
            <path
              d="M105.81 118.54a1.37 1.37 0 1 1-1.36-1.37 1.36 1.36 0 0 1 1.36 1.37z"
              fill="#8DADB2"
            />
            <path
              d="M105.18 118.54a.74.74 0 1 1-.73-.73.73.73 0 0 1 .73.73z"
              fill="#494949"
            />
            <path
              d="M96.36 44.36a1.16 1.16 0 1 1-2.32 0 1.16 1.16 0 0 1 2.32 0z"
              fill="#2E7FDB"
            />
            <path
              d="M95.82 44.36a.62.62 0 1 1-1.24 0 .62.62 0 0 1 1.24 0z"
              fill="#494949"
            />
            <path
              d="M89.78 41.75a1.29 1.29 0 1 1-1.29-1.29 1.3 1.3 0 0 1 1.29 1.29z"
              fill="#2E7FDB"
            />
            <path
              d="M89.18 41.75a.7.7 0 1 1-.69-.69.69.69 0 0 1 .69.69z"
              fill="#494949"
            />
            <path
              d="M54.46 38a1.29 1.29 0 1 1-2.58-.02 1.29 1.29 0 0 1 2.58.02z"
              fill="#2E7FDB"
            />
            <path
              d="M53.86 38a.69.69 0 1 1-1.38-.02.69.69 0 0 1 1.38.02z"
              fill="#494949"
            />
            <path
              d="M63.16 38.69A1.75 1.75 0 1 1 61.42 37a1.74 1.74 0 0 1 1.74 1.69z"
              fill="#2E7FDB"
            />
            <path
              d="M62.35 38.69a.94.94 0 1 1-1.88.02.94.94 0 0 1 1.88-.02z"
              fill="#494949"
            />
            <path
              d="M108.31 29.15a17.6 17.6 0 0 0-8.61 11.94c-1.91 8.76 4.43 21.69 13.36 22.83 0 0 1.83-10.15 1.67-12.68-1.02-15.67-6.42-22.09-6.42-22.09z"
              fill="#4C2D91"
            />
            <path
              d="M106.5 53.74l4.11 3.38-4 3.66a18.77 18.77 0 0 1-4.63-6.19c-.06-.11-.11-.23-.17-.35-.24-.47-.47-1-.69-1.52a1.75 1.75 0 0 1-.13-.33c-.22-.58-.47-1.38-.65-1.88a17.83 17.83 0 0 1-1.1-5.7v-.07c0-.55 0-1.08.06-1.59v-.39a20.72 20.72 0 0 1 2.88-7.76l4.15 2.56-2 4.16 2.08 2.48 5-.81 1.23 6.54-5.16.56-.98 3.25z"
              fill="#93278F"
            />
            <path
              d="M99.87 42.73h-.58v.39a4.3 4.3 0 0 1 .62 0 5.72 5.72 0 0 1 1.89 11.13c.06.12.11.24.17.35a6.11 6.11 0 0 0-2.06-11.86l-.04-.01z"
              fill="#4C2D91"
            />
            <path
              d="M127.18 52.49c0 .3-.13.77-.27 1.35 0 .13-.06.27-.09.41-.74 3.18-2.34 8.9-3 9.2-.18.08-5.26 1.71-7.64 2.47l-.36.11-.83.27-2.64-7.17 6.19-2.69L120 60l2-1.67.53-4.9 4.65-.94z"
              fill="#93278F"
            />
            <path
              d="M126.91 53.84c0 .13-.06.27-.09.41l-2.74.5-.29 4.84a.27.27 0 0 1-.06.12l-3.55 3.54a.21.21 0 0 1-.17 0 .17.17 0 0 1-.14-.12L118 58.52l-3.86 1.64 2.08 5.76.33.88a.21.21 0 0 1-.12.25h-.06a.18.18 0 0 1-.18-.13l-.33-.9-2.15-5.91a.2.2 0 0 1 .11-.24l4.18-1.78a.19.19 0 0 1 .15 0 .22.22 0 0 1 .1.11l1.85 4.58 3.3-3.29.3-4.91a.19.19 0 0 1 .16-.18l3.05-.56z"
              fill="#4C2D91"
            />
            <path
              d="M111.37 64.58s9.37-4.33 13.33-.51c3.96 3.82 2.29 9.44-1 13.39-3.29 3.95-12.63 13.65-17.22 13.65-4.59 0-4.41-1.11-3.48-4.11.93-3 8.37-22.42 8.37-22.42z"
              fill="#FFF"
            />
            <path
              d="M121.45 75.91a.45.45 0 0 1-.16 0 .38.38 0 0 1-.18-.51c1.57-3.37 1.82-5.72.75-7-1.62-1.93-5.81-.85-5.86-.84a.37.37 0 0 1-.46-.27.38.38 0 0 1 .27-.47c.19-.05 4.71-1.21 6.63 1.09 1.28 1.52 1.06 4.15-.64 7.81a.37.37 0 0 1-.35.19zM111.74 85.29a.38.38 0 0 1-.18-.72 21.88 21.88 0 0 0 5.86-4.83.38.38 0 0 1 .59.48 22.23 22.23 0 0 1-6.09 5 .39.39 0 0 1-.18.07zM104.15 83.14a.38.38 0 0 1-.1.27c-.83 1-18.1 20.36-30.38 20.36a9.23 9.23 0 0 1-5-1.38 17.57 17.57 0 0 0-9.14-2.86 15.12 15.12 0 0 0-6.81 1.36l-.31.29-.32-.81.27-.15a15.82 15.82 0 0 1 7.25-1.45 18.29 18.29 0 0 1 9.47 3C80 108.64 101.7 84.89 103.38 83c-.06-1.58-.09-14.22 8.68-19.32.27.07.81.15 1 .22-9.06 5.1-8.92 19.1-8.91 19.24z"
              fill="#2E7FDB"
            />
            <path
              d="M77.58 88.68c1.18-.57-8.21-1.28-10.42-2.56-4.27-2.46-4.71.94-6.32.94-1.21 0-1-1.89-2.57-2.39-1.57-.5-3.27.79-4.22 1.45a.39.39 0 0 0 .15.71c1.3.19 2.575.526 3.8 1A4.59 4.59 0 0 0 64.08 89s12.27.28 13.5-.32zM61.63 93.8a6.45 6.45 0 0 1-3.13-1.25l-.13-.09a.39.39 0 0 1 .43-.64l.13.09c1.12.76 2.82 1.9 6.37.45a.39.39 0 0 1 .5.21.38.38 0 0 1-.21.5 8.52 8.52 0 0 1-3.96.73z"
              fill="#2E7FDB"
            />
            <path
              d="M103.77 48.62a3.93 3.93 0 0 1-2.83 3.77c-.22-.58-.47-1.38-.65-1.88a17.83 17.83 0 0 1-1.1-5.7v-.07a4.62 4.62 0 0 1 .65 0 3.93 3.93 0 0 1 3.93 3.88z"
              fill="#4C2D91"
            />
            <path
              d="M61.64 81.14a10.3 10.3 0 0 1 3.87-1.43 16.25 16.25 0 0 1 5.09.64s-3.94-1.66-4.56-2c-.62-.34-1.83.24-2.43.64a15.49 15.49 0 0 0-1.97 2.15z"
              fill="#D9E6E8"
            />
            <path
              d="M72.09 80.25a.38.38 0 0 1-.42.35c-2.87-.28-3.41-.61-4.21-1.1a9.77 9.77 0 0 0-1.1-.61c-1.47-.67-2.54.32-3.52 1.4a2.77 2.77 0 0 1-.71.65 8.15 8.15 0 0 1-3.28.71A6.18 6.18 0 0 1 56 81a3.82 3.82 0 0 1-2.1-2.58c-.52-2.62.93-4.71 2.61-7.14a26.58 26.58 0 0 0 3.35-5.92l.35-.88c1.84-4.8 5.68-14.79 1.21-19.83-2.29-2.58-4.89-3.88-7.71-3.82a11.57 11.57 0 0 0-5 1.35l.27-1a12 12 0 0 1 4.7-1.12c3-.06 5.85 1.32 8.3 4.08 4.78 5.38.83 15.66-1.07 20.6l-.34.88a27.59 27.59 0 0 1-3.44 6.09c-1.65 2.37-2.95 4.25-2.49 6.55a3.06 3.06 0 0 0 1.7 2 6.53 6.53 0 0 0 5.48-.08 3.23 3.23 0 0 0 .46-.46c.81-.89 2.31-2.55 4.41-1.58.407.19.801.408 1.18.65.74.45 1.19.73 3.88 1a.38.38 0 0 1 .34.46z"
              fill="#D9E6E8"
            />
            <path
              d="M129.77 46.19c.44 3.18 4.1 4.8 4.93 4.44a7.75 7.75 0 0 0 2-2s-2.45-2.33-2.81-2.55c-.36-.22.14 1.34.53 1.64.39.3-5.04-4.33-4.65-1.53z"
              fill="#FDBC95"
            />
            <path
              fill="#608087"
              d="M112.3 136.87l-2.62-.11 17.67-54.77 2.41.78z"
            />
            <path
              fill="#608087"
              d="M124.591 123.536l-.345 2.507-10.045-1.384.345-2.506zM127.31 114.182l-.51 2.478-9.373-1.93.51-2.478zM130.3 104.944l-.51 2.478-9.373-1.93.51-2.477zM132.989 95.719l-.51 2.478-9.374-1.93.51-2.477z"
            />
            <path
              fill="#608087"
              d="M122.37 135.71h-2.66l13.63-42.25 1.67 3.09z"
            />
            <path
              fill="#E7F6F7"
              d="M151.17 136.14l-2.6.33-26.09-64.44 2.35-.96z"
            />
            <path
              fill="#E7F6F7"
              d="M138.724 80.539l.95 2.345-9.4 3.805-.95-2.345zM142.618 90.394l.95 2.345-9.4 3.805-.95-2.345zM147.038 103.175l.962 2.353-9.43 3.853-.962-2.353zM151.82 112.922l.949 2.345-9.4 3.805-.949-2.345z"
            />
            <path
              fill="#E7F6F7"
              d="M161.14 133.83l-2.61.29-26.09-64.45 2.35-.95z"
            />
            <path
              fill="#E7F6F7"
              d="M155.782 122.901l.95 2.346-9.4 3.805-.95-2.345z"
            />
            <path
              fill="#CCC"
              d="M153.43 72.5v24.12l-10.91-.01-.26-19.81 3.96-8.34z"
            />
            <path
              d="M155.28 121.69s-3 .82-5.27 1.25c-.528.1-.91.562-.91 1.1l5.56.07a9.34 9.34 0 0 0 3.71-.57v.5h1.89v-1.65a1.2 1.2 0 0 0-1.2-1.18l-3.78.48z"
              fill="#0C0C0C"
            />
            <path
              d="M157.58 68.46l-.58 26.7s3.27 23.44 3.45 26.71l-7.72.47-3.38-26.55-.86-24.72 9.09-2.61z"
              fill="#2E7FDB"
            />
            <path
              fill="#000"
              d="M158.3 122.01l.3-.04-3.9-26.59.12-22.42h-.31l-.12 22.44z"
              opacity=".24"
            />
            <path
              d="M139.13 103.43s-1.52.51-3.36 1a1.12 1.12 0 0 0-.84 1.16l5.56-.34a9.36 9.36 0 0 0 3.65-.84v.51l1.89-.14-.16-1.65a1.22 1.22 0 0 0-1.29-1.09l-5.45 1.39z"
              fill="#0C0C0C"
            />
            <path
              d="M142.67 65.49l-6.75 11.14s3.14 23.26 3 26.86l7.24-.05-2.34-25.09 4.7-5.95V71l-5.85-5.51z"
              fill="#2E7FDB"
            />
            <path
              fill="#2E63CA"
              d="M141.09 103.48h.38l-1.45-25.88 6.23-7.34-.38-.16-6.4 7.34z"
              opacity=".24"
            />
            <path
              d="M142.26 67.12c.13 3.42 3.54 4.49 6 4.3 4.73-.37 9-1.34 8.88-4.76-.12-3.42-4.09-6.06-8.83-5.87-4.74.19-6.19 2.9-6.05 6.33z"
              fill="#2E7FDB"
            />
            <path
              d="M154.66 65s0-14.68 1.25-20.68c.31-1.48-1.89-4.44-3.27-5.07l-.37-.39h-8.65l-.2.17c-2 1.83-1.63 6.3-1.54 10.1l.38 17.06 12.4-1.19z"
              fill="#2E63CA"
            />
            <path
              d="M149.22 30.7s-1 6.66 2.72 8.32l-8.13.13s2.14-3.22.45-6.34c0 0 3.79-2.81 4.96-2.11z"
              fill="#F1997C"
            />
            <path
              d="M144.72 33.91s2.94-2.2 2.25-1A5.6 5.6 0 0 1 144.9 35l-.18-1.09z"
              fill="#C1966B"
            />
            <path
              d="M150.5 27.24v.55c0 .18-.08.62-.14.93a6.75 6.75 0 0 1-5.18 5.18 2.58 2.58 0 0 1-2.7-.86 2.07 2.07 0 0 1-.4-1 6.19 6.19 0 0 1 0-.67v-.28c0-.1 0-.4.05-.63a26.42 26.42 0 0 1 .55-3.05 27 27 0 0 1 .93-2.78c.81-2 2.5-3 4.06-2.69 1.77.37 2.93 2.61 2.83 5.3z"
              fill="#F1997C"
            />
            <path
              d="M149.32 29.81s1.89-1.25 2.12-.31c.23.94-3.16 3.49-3.76 2.88-.6-.61 1.64-2.57 1.64-2.57z"
              fill="#F1997C"
            />
            <path
              d="M146.33 27.13a2.94 2.94 0 0 0-1.72-1.41c-.75-.11-1 .37-.82.36a3.48 3.48 0 0 1 1.27.37c.35.22 1.23.79 1.27.68z"
              fill="#2D2D2D"
            />
            <path
              d="M143.53 30.81a1.11 1.11 0 0 1-1 .66.85.85 0 0 1-.55-.11v-.28c0-.1 0-.4.05-.63.411.17.864.212 1.3.12a.16.16 0 0 1 .2.24z"
              fill="#FFF"
            />
            <path fill="#2D2D2D" d="M145.03 27.78l-1.09-.58-.13.27 1.22.54z" />
            <path
              d="M143.93 27.79c-.1.27-.05.53.11.59.16.06.37-.11.47-.38a.45.45 0 0 0-.2-.58c-.16-.06-.31.1-.38.37z"
              fill="#2D2D2D"
            />
            <path
              d="M149.85 36.84l-3.26.73-1.89-.57-1.22 2 9.16.19s-2.49-1.57-2.79-2.35z"
              fill="#A09D9F"
            />
            <path
              d="M143.24 39.15l.95 1 2.56-1.15 2.53 1.32L151 38l-.29-.3-.91-1.08a10.53 10.53 0 0 1-2.83.67 12 12 0 0 1-2.27-.29l-.7 1.25-.13.23-.63.67zM160.9 96.19l-4.13-37.55s.09-7.64-.43-13.18a9 9 0 0 0-5.17-7.29v.71l-.75 26.45.66 31.29 9.82-.43z"
              fill="#FFF"
            />
            <path
              d="M151.67 60.19l.15 2.58a2.18 2.18 0 0 0 2.18 2.08h.12a2.16 2.16 0 0 0 1.52-.73 2.19 2.19 0 0 0 .56-1.59l-.14-2.53a.16.16 0 0 0-.05-.11.14.14 0 0 0-.11 0l-4.08.22a.16.16 0 0 0-.15.08zm4.1-.07v.91l-3.78.2v-.9l3.78-.21zm-3.65 2.63l-.07-1.22 3.78-.2.07 1.21a1.893 1.893 0 0 1-3.78.21z"
              fill="#75AFBC"
            />
            <path
              d="M150.54 30.46h.06c.17-.22.23-.39.16-.51s-.49-.16-.53-.16a.08.08 0 0 0 0 .16c.1 0 .33 0 .37.07.04.07 0 .18-.14.34a.08.08 0 0 0 0 .11l.08-.01z"
              fill="#C1966B"
            />
            <path
              d="M142.79 27s-.73 1.38-1.58 1.64c-.69.22 1.31 1.28 1.31 1.28l.27-2.92z"
              fill="#F1997C"
            />
            <path
              d="M141.89 40.49l-1.54 4.92 1 1.67-.91 1.62 1.32 9.17a.16.16 0 1 0 .32 0l-.19-6.87 1.53-12-1.53 1.49zM151.17 38.17l.68 1.76-.83 2.78-.62 1.3 3.03 3.6L150.55 60l-.83-20.29.94-2.01z"
              fill="#C3DBDA"
            />
            <path
              fill="#416B72"
              d="M146.5 37.28l-.14 1.89.35-.14.35.12-.08-1.87z"
            />
            <path
              d="M58.81 56.88c.28-.11.92.55-.42 2.06-1.48 1.66-5.23 4.37-11.12 5.61a29 29 0 0 1-.27-3.46c3.32-.54 8.82-3.01 11.81-4.21z"
              fill="#2E7FDB"
            />
            <path
              d="M56.38 54.82c1.41.79 3 1.3 2.83 2.73 0 0-1.58.93-1.54.48.13-1.6-.15-2.07-1.72-2.76-.66-.27-.2-.79.43-.45zM76.14 57.22c-.83-.37-.9 1.26-.21 2.07 6.73 7.91 20.94 4.55 20.94 4.55a.69.69 0 0 0 .13-1.31 10.37 10.37 0 0 0-3.73-.82c-2.82-.09-8.91-.78-17.13-4.49z"
              fill="#2E7FDB"
            />
            <path
              d="M78.41 54.89c-1.41.78-2.66 1.55-2.91 2.68 0 0 1.65 1 1.62.52-.12-1.59.21-2.09 1.78-2.82.66-.27.1-.73-.49-.38zM125 66.14a1.37 1.37 0 1 1-1.36-1.36c.751 0 1.36.609 1.36 1.36z"
              fill="#2E7FDB"
            />
            <path
              d="M124.33 66.14a.73.73 0 1 1-1.46 0 .73.73 0 0 1 1.46 0z"
              fill="#494949"
            />
            <path
              d="M109 88.15a1.36 1.36 0 1 1-2.72 0 1.36 1.36 0 0 1 2.72 0z"
              fill="#2E7FDB"
            />
            <path
              d="M108.38 88.15a.73.73 0 1 1-1.46 0 .73.73 0 0 1 1.46 0z"
              fill="#2E7FDB"
            />
            <ellipse
              fill="#FFF"
              transform="rotate(-.21 622.017 -39555.253)"
              cx="3.844"
              cy="5.074"
              rx="3.6"
              ry="4.11"
              opacity=".35"
            />
            <path
              d="M145.93 6.68a5 5 0 0 1 .42-1.65c.07-.14.24-.27.36-.25.33.06.34.51.22.83a4.61 4.61 0 0 0-.27 1.22c0 .31-.21.52-.41.46a.55.55 0 0 1-.32-.61z"
              fill="#F4F4F4"
            />
            <path
              d="M151.45 3.24a.22.22 0 0 1-.13 0 .25.25 0 0 1-.07-.34l.85-1.23a.25.25 0 0 1 .34-.07.24.24 0 0 1 .06.34l-.85 1.24a.22.22 0 0 1-.2.06zM152.75 5.06a.25.25 0 0 1 0-.49l1.47-.25a.24.24 0 0 1 .29.19.26.26 0 0 1-.2.29l-1.48.25-.08.01zM144.63 5.09l-1.48-.24a.25.25 0 0 1-.2-.28.24.24 0 0 1 .28-.2l1.48.24a.25.25 0 0 1 0 .49l-.08-.01zM148.63 2.37a.26.26 0 0 1-.25-.24V.63a.26.26 0 0 1 .24-.25.25.25 0 0 1 .25.24v1.5a.24.24 0 0 1-.23.25h-.01zM146 3.33a.27.27 0 0 1-.19-.08l-1-1.14a.23.23 0 0 1 0-.34.24.24 0 0 1 .34 0l1 1.14a.24.24 0 0 1 0 .34.27.27 0 0 1-.15.08z"
              fill="#FFF"
            />
            <path
              fill="#020202"
              d="M138.77 55.86l3.33 2.95.05 2.03-3.39-3.48z"
              opacity=".15"
            />
            <path
              d="M135.41 47.33a20.44 20.44 0 0 0-2.18 3l8.05 8.49a5.49 5.49 0 0 0 8.26-2l5-10.13-3.13-8.07L145 52.66l-9.59-5.33z"
              fill="#FFF"
            />
            <path
              d="M149.59 23.49a2.36 2.36 0 0 1-2.31.66 2.42 2.42 0 0 1-1.36-.95 2.35 2.35 0 0 1-.17-2.36 2 2 0 0 1 .13-.25 2.24 2.24 0 0 1 .27-.34 2.36 2.36 0 0 1 3.34-.09 2.3 2.3 0 0 1 .62 1c.057.162.094.33.11.5v.12a2.36 2.36 0 0 1-.63 1.71z"
              fill="#593730"
            />
            <path
              d="M153.61 26.65l-.09.09a2.72 2.72 0 0 1-.38.31h-.06a3.2 3.2 0 0 1-3 .34 3.25 3.25 0 0 1-1-.66 3.2 3.2 0 0 1 1.24-5.38h.2a3.1 3.1 0 0 1 .42-.08 3.2 3.2 0 0 1 2.67 5.39v-.01z"
              fill="#593730"
            />
            <path
              d="M151.79 27.44a1.8 1.8 0 0 1-.62.42h-.15l-.2.05a1.78 1.78 0 0 1-2-1.28 2.22 2.22 0 0 1-.06-.51 1.73 1.73 0 0 1 .49-1.17 1.77 1.77 0 0 1 2.5-.07l.06.06.08.09a2 2 0 0 1 .26.4 1.79 1.79 0 0 1-.36 2.01zM147.92 21.72a1.79 1.79 0 0 1-2.51.07 1.93 1.93 0 0 1-.47-.77 1.69 1.69 0 0 1-.08-.5 1.79 1.79 0 0 1 .49-1.24 1.77 1.77 0 0 1 2.37-.18l.13.11.17.18a1.8 1.8 0 0 1 .21.35 1.76 1.76 0 0 1-.31 1.98z"
              fill="#593730"
            />
          </g>
        </g>
      </g>
    </g>
  </svg>
);

export default Badge;



// WEBPACK FOOTER //
// ./src/components/SVG/Badge5.js